import { NavLink } from 'react-router-dom';
import partners from '../team-data/partners';
import '../index.css';
import './PartnersCarousel.css';

function About(){
    return(
        <section className="container-fluid px-3 px-md-5 py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10">
                    {/* Section Header */}
                    <div className="text-center mb-5">
                        <h2 className="text-display mb-4" style={{fontSize: 'clamp(2rem, 4vw, 3rem)', color: 'var(--gray-800)'}}>
                            Our Partners
                        </h2>
                        <p className="lead text2 text-muted mb-5" style={{fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto'}}>
                            Together with our trusted partners, we're building a stronger future for African youth through collaborative impact.
                        </p>
                    </div>

                    {/* Partners Carousel */}
                    <div className="partners-carousel-container">
                        <div className="partners-carousel">
                            <div className="partners-track">
                                {/* First set of partners */}
                                {partners.map((partner) => (
                                    <a 
                                        key={partner.id}
                                        href={partner.website} 
                                        target={partner.website.startsWith('#') ? '_self' : '_blank'}
                                        className="partner-logo-link" 
                                        rel="noopener noreferrer"
                                        title={`${partner.name} - ${partner.description}`}
                                    >
                                        <img 
                                            src={partner.logo} 
                                            alt={`${partner.name} Logo`} 
                                            className="partner-logo"
                                        />
                                    </a>
                                ))}
                                {/* Duplicate set for seamless loop */}
                                {partners.map((partner) => (
                                    <a 
                                        key={`${partner.id}-duplicate`}
                                        href={partner.website} 
                                        target={partner.website.startsWith('#') ? '_self' : '_blank'}
                                        className="partner-logo-link" 
                                        rel="noopener noreferrer"
                                        title={`${partner.name} - ${partner.description}`}
                                    >
                                        <img 
                                            src={partner.logo} 
                                            alt={`${partner.name} Logo`} 
                                            className="partner-logo"
                                        />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Call to Action */}
                    <div className="text-center mt-5">
                        <div className="card-glass p-4 rounded-4 d-inline-block">
                            <h5 className="text1 mb-3" style={{color: 'var(--gray-800)'}}>
                                Want to Partner With Us?
                            </h5>
                            <p className="text2 text-muted mb-3" style={{maxWidth: '400px'}}>
                                Join our network of partners making a difference in youth empowerment across Africa.
                            </p>
                            <NavLink to="/#contact" className="btn-modern btn-primary"
                                onClick={(e) => {
                                  // If we're already on the home page, scroll to contact
                                  if (window.location.pathname === '/') {
                                    e.preventDefault();
                                    const contactSection = document.getElementById('contact');
                                    if (contactSection) {
                                      contactSection.scrollIntoView({ behavior: 'smooth' });
                                    }
                                  }
                                }}
                            >
                                <i className="bi bi-handshake me-2"></i>
                                Get In Touch
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About